// FE numeric sibling is missing `EntityField` entirely; doc lists all 3.
export default Object.freeze({
  FormField: 'form-field',
  Variable: 'variable',
  EntityField: 'entity-field',
});
